import { render, staticRenderFns } from "./budget-event-main.vue?vue&type=template&id=41bb5265&scoped=true&"
import script from "./budget-event-main.vue?vue&type=script&lang=ts&"
export * from "./budget-event-main.vue?vue&type=script&lang=ts&"
import style0 from "./budget-event-main.vue?vue&type=style&index=0&id=41bb5265&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41bb5265",
  null
  
)

export default component.exports